const loadScripts = (data: any) => {
    if (!!window) {
      window.document.head.insertAdjacentHTML("beforeend", data);
    }
};

function getCookie(name: string) {
  const cookies = document.cookie.split(";");
  let cookieValue = null;

  cookies.forEach((cookie) => {
    const splitCookie = cookie.split("=");
    const cookieName = splitCookie[0].trim();

    if (cookieName === name) {
      cookieValue = splitCookie[1];
    }
  });

  return cookieValue;
}


function handleUnauthorizedResponse(res: Response) {
  if (res.status === 403) {
    console.log("Sorry, Please log in");
    setTimeout(() => {
      window.location.href = `${window.location.protocol}//${window.location.host}/login/`;
    }, 2000);
  } else {
    console.log("Something went wrong");
  }
}

const loadTags = (page: string, callback: (arg0: any) => void) => {
  fetch("/api/load-tags/?page=" + page)
      .then((response) => response.json())
      .then((data) => {
        callback(data)
      })
      .catch((error) => {
        console.error("Error:", error);
      })
   
}

const sendRps = () => {
  const queryString = window.location.search;
  fetch(`/rps/${queryString}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-CSRFToken": `${getCookie("csrftoken")}`,
    },
    body: new URLSearchParams({
      csrfmiddlewaretoken: `${getCookie("csrftoken")}`,
      referrer: document.referrer,
      entry_page: window.location.pathname,
    }).toString(),
  });
}

export { loadTags, sendRps, getCookie, loadScripts };
